import React from "react";
import { Container, Segment, Image } from "semantic-ui-react";

import logoWithClaim from "../logo.png";

export interface HDNewIssueProps {}

const HDFooter = () => {
    return (
        <Segment
            vertical
            style={{ margin: "0em 0em 0em", padding: "5em 0em", backgroundColor: "#4a4a4a" }}>
            <Container
                textAlign="center"
                style={{ backgroundColor: "#4a4a4a", color: "white", textAlign: "center" }}>
                <a href="https://hawadawa.com/">
                    <Image
                        centered
                        size="small"
                        src={logoWithClaim}
                        alt="Bernard - The future of air quality management"
                    />
                </a>
                <div style={{ fontWeight: 500 }}>
                    <br />
                    &copy; {new Date().getFullYear()} Bernard Technologies GmbH - All Rights Reserved.
                </div>
            </Container>
        </Segment>
    );
};
export default HDFooter;
